// extracted by mini-css-extract-plugin
export var body = "_kr-0";
export var sectionHeader = "_kr-4";
export var shortcutColumns = "_kr-2";
export var shortcutList = "_kr-1";
export var shortcutSection = "_kr-3";